import React from 'react';

const WorkflowIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect
      x="2.40915"
      y="12.4422"
      width="3.95947"
      height="3.95947"
      rx="1.97973"
      transform="rotate(-90 2.40915 12.4422)"
      stroke={props.stroke || '#96919B'}
      strokeWidth="1.5"
    />
    <rect
      x="13.6314"
      y="17.75"
      width="3.95947"
      height="3.95947"
      rx="1.97973"
      transform="rotate(-90 13.6314 17.75)"
      stroke={props.stroke || '#96919B'}
      strokeWidth="1.5"
    />
    <rect
      x="13.6314"
      y="6.37613"
      width="3.95947"
      height="3.95947"
      rx="1.97973"
      transform="rotate(-90 13.6314 6.37613)"
      stroke={props.stroke || '#96919B'}
      strokeWidth="1.5"
    />
    <path
      d="M13.033 16.0736V16.0736C11.5673 16.0736 10.3791 14.8854 10.3791 13.4197L10.3791 10.3866M13.033 4.69969V4.69969C11.5673 4.69969 10.3791 5.88788 10.3791 7.3536L10.3791 10.3866M10.3791 10.3866L6.96696 10.3866"
      stroke={props.stroke || '#96919B'}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default WorkflowIcon;
